import { Button } from "melco-ui";
import { Key } from "react";
import { useTranslation } from "react-i18next";
import { useAddRemoveMachineGroups } from "../../../hooks/reporting/useAddRemoveMachineGroup";
import { useFormikContext } from "formik";
import { ReportingMelcoMachineStatisticsModelsGroupListItem } from "melco-shared-logic";

export type BulkActionAddAndSaveMachineGroupsProps = {
  allMachineGroups?: ReportingMelcoMachineStatisticsModelsGroupListItem[];
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionAddAndSaveMachineGroups: React.FC<
  BulkActionAddAndSaveMachineGroupsProps
> = ({ allMachineGroups, selectedRowKeys, setSelectedRowKeys }) => {
  const { t } = useTranslation();
  const { addGroups } = useAddRemoveMachineGroups();
  const { submitForm } = useFormikContext();

  return (
    <>
      {selectedRowKeys.length > 0 && (
        <Button
          onClick={() => {
            if (allMachineGroups) {
              const machineGroupsToAddAndSave = allMachineGroups.filter(
                (c: any) => {
                  return selectedRowKeys.includes(c.name!);
                }
              );

              addGroups(machineGroupsToAddAndSave);
              setSelectedRowKeys([]);
              submitForm();
            }
          }}
        >
          {t("reporting.machinestatus.view.machinegroups.add_selected")}
        </Button>
      )}
    </>
  );
};
